import React, { useEffect, useRef } from 'react';
import './Hero.css';
import { HERO, CONTACT } from '../content';

export default function Hero() {
  const video = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const el = video.current;
    if (!el) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    el.src = `${process.env.PUBLIC_URL}/media/${HERO.clip}.webm`;
    el.play().catch(() => {});
  }, []);

  return (
    <section id="top" className="hero">
      <div className="hero-bg" aria-hidden="true">
        {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
        <video
          ref={video}
          poster={`${process.env.PUBLIC_URL}/media/${HERO.clip}.jpg`}
          preload="none"
          loop
          muted
          playsInline
        />
        <div className="hero-scrim" />
      </div>

      <div className="wrap hero-inner">
        <p className="eyebrow hero-location">{HERO.location}</p>

        <h1 className="hero-name">{HERO.name}</h1>
        <p className="hero-role">{HERO.role}</p>

        <p className="hero-lede">{HERO.lede}</p>

        <div className="hero-actions">
          <a href="#work" className="btn btn--primary">
            See the work
          </a>
          <a href={CONTACT.resume} className="btn" download>
            Résumé
            <svg viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
              <path d="M8 1v10M4 7.5 8 11.5l4-4M2 14.5h12" />
            </svg>
          </a>
          <a href={`mailto:${CONTACT.email}`} className="btn">
            {CONTACT.email}
          </a>
        </div>

        <ul className="hero-skills">
          {HERO.skills.map((s) => (
            <li key={s}>{s}</li>
          ))}
        </ul>
      </div>
    </section>
  );
}
